import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { switchMap } from 'rxjs/operators';
import { IndexedDbService } from 'src/app/shared/services/indexed-db.service';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {
  
  constructor(private db: IndexedDbService) {

  }

  private getToken$(): Observable<string | null> {
    // 1️⃣ Try sync storage first
    const syncToken =
      localStorage.getItem('UPGRAD_IPJ_TOKEN') ||
      sessionStorage.getItem('UPGRAD_IPJ_TOKEN');

    if (syncToken) {
      return from(Promise.resolve(syncToken));
    }

    // 2️⃣ Fallback to IndexedDB (async)
    console.log(from(this.db.getToken()), 'from(this.db.getToken())')
    return from(this.db.getToken());
  }

  
  getToken() {
    const data = localStorage.getItem("UPGRAD_IPJ_TOKEN") || sessionStorage.getItem('UPGRAD_IPJ_TOKEN') || this.db.getToken();
    return (data ? data : null);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if(req.urlWithParams.search("fetch-certificate") < 0 && req.urlWithParams.search('chat-bot.harappa.education') < 0 ){
    //   req = req.clone({
    //     setHeaders: {
    //       'Authorization': `${this.getToken()}`
    //     },
    //   });
    // }
    // return next.handle(req);
    if (
      req.urlWithParams.includes('fetch-certificate') ||
      req.urlWithParams.includes('chat-bot.harappa.education')
    ) {
      return next.handle(req);
    }

    return this.getToken$().pipe(
      switchMap(token => {
        if (!token) {
          return next.handle(req);
        }

        const authReq = req.clone({
          setHeaders: {
            Authorization: token
          },
          withCredentials: true
        });

        return next.handle(authReq);
      })
    );
  }
}